import axios from 'axios';
import { HttpMethods, APIContexts } from 'enums';
import { apiRequestHandler, apiHost } from '.';

const apiContext = `${APIContexts.TITLE_GROUP}/`;

export const GetTitleAPI = ({ queryParams, onSuccess, ...rest }) => {
  const api = 'GetTitle';
  const endpoint = `${apiHost}${apiContext}${api}/${queryParams.id}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const GetTitlesFromGroupAPI = ({ queryParams, onSuccess, ...rest }) => {
  const api = 'GetTitlesFromGroup';
  const titleIdsParameter = queryParams.titleIds
    ? `&titleIds=${queryParams.titleIds
        .map((value) => value.titleId)
        .join(',')}`
    : '';
  const endpoint = `${apiHost}${apiContext}${api}?groupId=${queryParams.groupId}${titleIdsParameter}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const GetTitleGroupsAPI = ({ queryParams, onSuccess, ...rest }) => {
  const api = 'GetTitleGroups';
  const channelParameters = queryParams.channelID
    ? `&channelID=${queryParams.channelID}`
    : '';
  const excludeGroupsWithNoTitlesParameters = `&excludeGroupsWithNoTitles=${queryParams.excludeNoTitles ??
    false}`;
  const excludeGroupsDateParameters =
    queryParams.startDate && queryParams.endDate
      ? `&startDate=${queryParams.startDate}&endDate=${queryParams.endDate}`
      : ``;
  const endpoint = `${apiHost}${apiContext}${api}?prioritisedTitleGroupIds=${queryParams.titleGroupIds}${channelParameters}${excludeGroupsWithNoTitlesParameters}${excludeGroupsDateParameters}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const GetPrioritisedTitleGroupsAPI = ({
  queryParams,
  onSuccess,
  ...rest
}) => {
  const api = 'GetPrioritisedTitleGroups';
  const endpoint = `${apiHost}${apiContext}${api}?channelId=${queryParams.channelId}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const GetTitleGroupLookupAPI = ({ queryParams, onSuccess, ...rest }) => {
  const api = 'GetTitleGroupLookup';
  const endpoint = `${apiHost}${apiContext}${api}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const ImportTitleGroupAPI = ({ file }) => {
  const formData = new FormData();
  formData.append('file', file);
  const api = 'ImportTitleGroup';
  const url = `${apiHost}${apiContext}${api}`;
  return axios.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
